var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 48,
    viewBox: "0 0 104 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2465 20.4506C36.4652 17.5346 34.7435 14.9578 32.3484 13.1201C29.9534 11.2823 27.0189 10.2861 24 10.2861C20.9811 10.2861 18.0465 11.2823 15.6515 13.1201C13.2564 14.9578 11.5347 17.5346 10.7534 20.4506L14.7274 21.5154C15.2743 19.4742 16.4795 17.6705 18.156 16.384C19.8326 15.0976 21.8867 14.4003 24 14.4003C26.1132 14.4003 28.1674 15.0976 29.8439 16.384C31.5204 17.6705 32.7256 19.4742 33.2726 21.5154L37.2465 20.4506Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7534 27.5333C11.5348 30.4493 13.2565 33.026 15.6515 34.8638C18.0466 36.7016 20.9811 37.6978 24 37.6978C27.0189 37.6978 29.9534 36.7016 32.3485 34.8638C34.7435 33.026 36.4652 30.4493 37.2466 27.5333L33.2726 26.4685C32.7257 28.5097 31.5205 30.3134 29.8439 31.5999C28.1674 32.8863 26.1132 33.5836 24 33.5836C21.8868 33.5836 19.8326 32.8863 18.1561 31.5998C16.4795 30.3134 15.2744 28.5097 14.7274 26.4685L10.7534 27.5333Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5144,
    y: 21.9868,
    width: 10.9711,
    height: 4.11416,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9429,
    y: 6.17188,
    width: 4.11416,
    height: 35.656,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8535 14.6583C61.2313 14.6583 62.4438 14.9339 63.4909 15.4574C64.538 15.981 65.3647 16.725 65.9434 17.6895C66.5221 18.6815 66.8252 19.8113 66.8252 21.0789C66.8252 22.374 66.5221 23.5038 65.9434 24.4683C65.3647 25.4327 64.538 26.1767 63.4909 26.7003C62.4438 27.2239 61.2313 27.4719 59.8535 27.4719H56.1334V33.9476H52V14.6583H59.8535ZM56.1334 24.0274H59.4677C60.4322 24.0274 61.2037 23.7794 61.7824 23.2282C62.3335 22.7047 62.6367 21.9882 62.6367 21.0789C62.6367 20.1695 62.3335 19.4531 61.7824 18.9019C61.2037 18.3784 60.4322 18.1028 59.4677 18.1028H56.1334V24.0274Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3935 14.5205C72.8068 14.9338 73.0273 15.4574 73.0273 16.0637C73.0273 16.6974 72.8068 17.221 72.3935 17.6344C71.9526 18.0752 71.429 18.2681 70.7952 18.2681C70.1339 18.2681 69.6103 18.0752 69.1694 17.6344C68.7285 17.221 68.5356 16.6974 68.5356 16.0637C68.5356 15.4574 68.7285 14.9338 69.1694 14.5205C69.6103 14.1072 70.1339 13.8867 70.7952 13.8867C71.429 13.8867 71.9526 14.1072 72.3935 14.5205ZM68.8387 19.7837H72.7241V33.9476H68.8387V19.7837Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4317 14.6583H79.3171V25.8185L84.8835 19.7837H89.2374L84.1946 25.3225L89.5129 33.9476H85.0213L81.439 28.2159L79.3171 30.5031V33.9476H75.4317V14.6583Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 19.7837V33.9476H100.556L100.197 32.2391C99.7014 32.8453 99.1227 33.2862 98.4613 33.6169C97.8 33.9476 96.9733 34.1129 96.0364 34.1129C94.383 34.1129 93.0328 33.6169 91.9856 32.5973C90.9385 31.5777 90.4149 29.8693 90.4149 27.4719V19.7837H94.3004V27.0034C94.3004 28.2986 94.5208 29.263 94.9617 29.9244C95.4026 30.5857 96.1191 30.8888 97.056 30.8888C98.0204 30.8888 98.7644 30.5306 99.3156 29.8141C99.8391 29.0977 100.115 28.0781 100.115 26.7554V19.7837H104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/Footerlogo.a82764e90bc426f9ad09dcff69bec5ba.svg";
export { ForwardRef as ReactComponent };